import { render } from "./CompanyMetaData.vue?vue&type=template&id=beb056f4"
import script from "./CompanyMetaData.vue?vue&type=script&lang=js"
export * from "./CompanyMetaData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__